export default __webpack_public_path__ + "static/miracle-dental-logo-cf54a13b414167530d95463ec6537409.png";